<style></style>
<template>
  <div class="col-12">
    <div class="content-box">
      <div class="support-index" :class="{ 'show-ticket-content': seleccionada }">
        <div class="support-tickets">
          <div class="support-tickets-header">
            <div>
              <router-link
                class="back-to-index"
                href="#"
                :to="{ name: 'wms-recepcion', params: {} }"
              >
                <i class="os-icon os-icon-arrow-left5" style="color: purple"></i>
                <span style="color: purple">Listado</span>
              </router-link>
            </div>
            <br />
            <div class="element-box" style="background-color: #ffffff">
              <div class="tickets-control">
                <div class="element col-8" style="position: text-left">
                  <h5 v-if="current.tienda_obj" class="text-success">
                    {{ current.tienda_obj.nombre }}
                  </h5>
                </div>
                <div class="badge badge-danger col-4" v-if="current.estado == '9'">
                  Anulada
                </div>
                <div class="badge badge-success col-4" v-if="current.estado == 'A'">
                  Abierta
                </div>
                <div class="badge badge-dark col-4" v-if="current.estado == 'C'">
                  Finalizada
                </div>
              </div>
              <div>
                <h6>Recepción #{{ current.numero }}</h6>
                <div class="tickets-filter">
                  <div class="ae-item with-status status-green">
                    <div class="aei-content">
                      <div v-if="current.proveedor_obj" class="aei-title">
                        {{ current.proveedor_obj.codigo }} -
                        {{ current.proveedor_obj.nombre }}
                      </div>
                      <div v-if="current.proveedor_obj" class="aei-title">
                        Nit: {{ current.proveedor_obj.nit }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row col-12">
                  <div style="text-align: left" v-if="current.estado == 'A'">
                    <button
                      class="btn btn-md btn-info"
                      data-target="#modalCrearEtiqueta"
                      data-toggle="modal"
                      type="button"
                    >
                      Etiquetas
                      <i class="fas fa-print"></i>
                    </button>
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <div style="text-align: right">
                    <button
                      class="btn btn-md btn-dark"
                      type="button"
                      v-if="current.estado == 'A'"
                      @click="finalizarRecepcion"
                    >
                      Finalizar Recepción
                      <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
                <button
                  class="btn btn-md btn-info"
                  @click="reporteDiferencia(current)"
                  v-if="current.estado == 'C'"
                  type="button"
                >
                  Diferencia de Precios
                </button>
                &nbsp;
                <button
                  class="btn btn-md btn-success"
                  @click="reporteDevolucion(current)"
                  v-if="current.estado == 'C'"
                  type="button"
                >
                  Reporte Facturas
                </button>
              </div>
            </div>
            <div class="col-12">
              <div>
                <br />
                <h5 v-if="tipo == 'FACTURAS'">Facturas en Recepción</h5>
                <br v-if="tipo == 'FACTURAS'" />
                <h5 v-if="tipo == 'BULTOS'">Bultos</h5>
                <br v-if="tipo == 'BULTOS'" />
                <div class="tickets-filter" style="margin-bottom: 0px">
                  <div class="form-group element">
                    <label class="d-none d-md-inline-block mr-2">Tipo</label>
                    <select class="form-control-sm" v-model="tipo">
                      <option value="FACTURAS">Facturas</option>
                      <option value="BULTOS">Bultos</option>
                    </select>
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <div class="form-group mr-1">
                    <label class="d-none d-md-inline-block mr-2">Status</label>
                    <select class="form-control-sm">
                      <option value="A">Abierta</option>
                      <option value="B">Cerrada</option>
                      <option value="C">Finalizada</option>
                      <option value="9">Anulada</option>
                    </select>
                  </div>
                  &nbsp;&nbsp;
                  <div v-if="current.estado == 'A'">
                    <button
                      class="btn btn-success btn-block"
                      data-target="#modalFactura"
                      data-toggle="modal"
                      @click="id_factura_editar = null"
                      type="button"
                    >
                      Agregar Factura
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row col-12" v-if="current.estado == 'A'">
            <div class="col-6">
              <RecepcionFacturaModalComponent
                :recepcion="current"
                :factura_id="id_factura_editar"
                @refresh="refreshCurrent"
              />
            </div>
            <div class="col-6">
              <div
                aria-labelledby="exampleModalLabelEtiqueta"
                class="modal fade"
                id="modalCrearEtiqueta"
                role="dialog"
                tabindex="-1"
                aria-hidden="true"
                style="display: none"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabelEtiqueta">
                        Etiquetas &nbsp;
                        <button @click="imprimirAll" class="btn btn-sm btn-info">
                          Imprimir Todas
                        </button>
                      </h5>
                      <button
                        aria-label="Close"
                        class="close"
                        data-dismiss="modal"
                        type="button"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div class="modal-body text-left">
                      <div class="row">
                        <div class="col-12">
                          <div class="invoice-table">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>Etiqueta</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="detalle in current.recepcionetiqueta_set"
                                  :key="detalle.id"
                                >
                                  <td>{{ detalle.etiqueta }}</td>
                                  <td class="text-center">
                                    <button
                                      class="btn btn-info btn-sm"
                                      @click="imprimir(detalle)"
                                    >
                                      <i class="fa fa-print"></i>
                                    </button>
                                    &nbsp;
                                    <button
                                      class="btn btn-danger btn-sm"
                                      @click="eliminar(detalle)"
                                    >
                                      <i class="fa fa-times"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              v-bind:class="{
                                'text-danger':
                                  nueva_etiqueta.errors.cantidad &&
                                  nueva_etiqueta.errors.cantidad.length > 0,
                              }"
                              >Cantidad:</label
                            >
                            <input
                              v-on:keyup.enter="crearEtiquetas"
                              v-model="nueva_etiqueta.cantidad"
                              class="form-control"
                              placeholder="Cantidad"
                              v-bind:class="{
                                'is-invalid':
                                  nueva_etiqueta.errors.cantidad &&
                                  nueva_etiqueta.errors.cantidad.length > 0,
                              }"
                              type="number"
                              step="1"
                              min="1"
                            />
                            <small
                              v-if="
                                nueva_etiqueta.errors && nueva_etiqueta.errors.cantidad
                              "
                              class="form-text text-danger"
                              >{{ nueva_etiqueta.errors.cantidad[0] }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-info" @click="crearEtiquetas">
                        Crear Etiquetas <i class="fas fa-plus"></i>
                      </button>
                      <button class="btn btn-danger" data-dismiss="modal" type="button">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          &nbsp;&nbsp;&nbsp;
          <br />
          <div v-if="tipo == 'FACTURAS'">
            <RecepcionFacturaTicketComponent
              v-for="facturae in current.facturae_set"
              :key="facturae.id"
              :facturae="facturae"
              @seleccion="seleccionar"
            />
          </div>
        </div>
        <div class="support-ticket-content-w">
          <div class="support-ticket-content">
            <div
              class="support-ticket-content-header mb-0"
              v-if="seleccionada"
              style="display: block"
            >
              <a class="back-to-index" href="#" @click="seleccionada = null">
                <i class="os-icon os-icon-arrow-left5" style="color: purple"></i>
                <span style="color: purple">Atrás</span>
              </a>
              <div class="element-actions text-right">
                &nbsp; &nbsp;
                <div class="btn-group">
                  <button
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <i class="fa fa-cogs"></i>
                    Acciones
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button
                      class="dropdown-item"
                      @click="openModalEditarFact"
                      :disabled="seleccionada.estado != 'A'"
                      data-toggle="modal"
                      type="button"
                    >
                      <i class="far fa-edit"></i>
                      Editar Factura
                    </button>
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="cerrarFactura"
                      :disabled="seleccionada.estado != 'A'"
                    >
                      <i class="fas fa-folder"></i>
                      Cerrar Factura
                    </button>
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="abrirFactura"
                      :disabled="seleccionada.estado != 'B'"
                    >
                      <i class="fas fa-folder-open"></i>
                      Abrir Factura
                    </button>
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="autorizarTodo"
                      :disabled="seleccionada.estado == 'C' || seleccionada.estado == '9'"
                    >
                      <i class="fa fa-thumbs-up"></i>
                      Autorizar Todo
                    </button>
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="anular"
                      :disabled="seleccionada.estado == 'C' || seleccionada.estado == '9'"
                    >
                      <i class="fas fa-file-excel"></i>
                      anular Factura
                    </button>
                    <button
                      class="dropdown-item"
                      type="button"
                      data-toggle="modal"
                      data-target="#subirfactura"
                    >
                      <i class="fas fa-cloud-upload-alt"></i>
                      Subir Factura Escaneada
                    </button>
                    <button
                      class="dropdown-item"
                      type="button"
                      data-toggle="modal"
                      data-target="#referenciaModal"
                    >
                      <i class="fa fa-quote-left"></i>
                      Agregar Referencia
                    </button>
                  </div>
                </div>
              </div>
              <br />
              <div style="text-align: center">
                <h3 class="ticket-header">Detalle de Factura</h3>
                <span
                  v-bind:class="{
                    'badge badge-danger': seleccionada.estado == '9',
                    'badge badge-success': seleccionada.estado == 'A',
                    'badge badge-WarningP': seleccionada.estado == 'B',
                    'badge badge-dark': seleccionada.estado == 'C',
                  }"
                  >{{ seleccionada.estado_str }}</span
                >
              </div>
              <br />
              <div>
                <br />
                <b>Datos de Factura:</b>
                <br />
                Fecha: {{ seleccionada.fecha_documento }}
                <br />
                Serie: {{ seleccionada.serie }}
                <br />
                Factura: #{{ seleccionada.documento }}
                <br />
                <div style="text-align: right">
                  Total Factura: <b>Q {{ seleccionada.total_documento }}</b>
                  <br />
                  Total Conteo: <b>Q {{ seleccionada.total_precio_real }}</b>
                </div>
              </div>
              <div>
                <hr />
                <b>Complementarios:</b>
                <br />
                Recepción: #{{ current.numero }}
                <br />
                Proveedor:
                <br />
                {{ seleccionada.proveedor_obj.codigo }} -
                {{ seleccionada.proveedor_obj.nombre }}
                <br />
                Nit Proveedor: {{ seleccionada.proveedor_obj.nit }}
                <br />
                <br />
                <div style="text-align: right">
                  <a
                    v-if="seleccionada.archivo"
                    target="_blank"
                    :href="seleccionada.archivo"
                    class="btn btn-secondary btn-sm"
                    >Archivo Subido <i class="fas fa-eye"></i
                  ></a>
                  <span v-if="!seleccionada.archivo" class="btn badge badge-warning"
                    >Sin Archivo Escaneado <i class="fas fa-unlink"></i
                  ></span>
                  &nbsp;&nbsp;
                  <button @click="refreshAll()" class="btn btn-sm btn-info">
                    Actualizar <i class="fas fa-sync"></i>
                  </button>
                </div>
              </div>
              <div class="badge badge-danger" v-if="current.estado == '9'">
                Recepción Anulada
              </div>
            </div>
            <RecepcionFacturaDetalleComponent
              :facturae="seleccionada"
              :recepcion="current"
              @seleccion="seleccionar"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalFactura1"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: auto"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Factura</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body text-left">
            <div class="form-group">
              <label
                v-bind:class="{
                  'text-danger': factura.errors && factura.errors.fecha_documento,
                }"
                >Fecha Documento</label
              >
              <datepicker
                :format="'dd/MM/yyyy'"
                :bootstrap-styling="true"
                v-on:keyup.enter="editarFactura"
                v-bind:class="{
                  'is-invalid': factura.errors && factura.errors.fecha_documento,
                }"
                v-model="factura.fecha_documento"
              ></datepicker>
              <small
                v-if="factura.errors && factura.errors.fecha_documento"
                class="form-text text-danger"
                >{{ factura.errors.fecha_documento[0] }}</small
              >
            </div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': factura.errors && factura.errors.serie,
                    }"
                    >Serie:</label
                  >
                  <input
                    v-model="factura.serie"
                    class="form-control"
                    placeholder="Serie"
                    v-on:keyup.enter="editarFactura"
                    v-bind:class="{
                      'is-invalid': factura.errors && factura.errors.serie,
                    }"
                    type="text"
                  />
                  <small
                    v-if="factura.errors && factura.errors.serie"
                    class="form-text text-danger"
                    >{{ factura.errors.serie[0] }}</small
                  >
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': factura.errors && factura.errors.documento,
                    }"
                    ># Factura:</label
                  >
                  <input
                    v-model="factura.documento"
                    class="form-control"
                    placeholder="# Factura"
                    v-on:keyup.enter="editarFactura"
                    v-bind:class="{
                      'is-invalid': factura.errors && factura.errors.documento,
                    }"
                    type="text"
                  />
                  <small
                    v-if="factura.errors && factura.errors.documento"
                    class="form-text text-danger"
                    >{{ factura.errors.documento[0] }}</small
                  >
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': factura.errors && factura.errors.total_documento,
                    }"
                    >Total:</label
                  >
                  <input
                    v-model="factura.total_documento"
                    class="form-control"
                    v-on:keyup.enter="editarFactura"
                    placeholder="Total"
                    v-bind:class="{
                      'is-invalid': factura.errors && factura.errors.total_documento,
                    }"
                    type="number"
                    step="0.01"
                  />
                  <small
                    v-if="factura.errors && factura.errors.total_documento"
                    class="form-text text-danger"
                    >{{ factura.errors.total_documento[0] }}</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="editarFactura" type="button">
              <span>Editar Factura</span>
            </button>
            <button
              class="btn btn-secondary"
              data-dismiss="modal"
              type="button"
              ref="cerrarModalFactura"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
    <SubirFacturaScanModalComponent :current="seleccionada" />
    <ReferencialModalComponent :current="seleccionada" />
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import RecepcionService from "@/services/wms/RecepcionService";
import RecepcionFacturaEService from "@/services/wms/RecepcionFacturaEService";
import RecepcionFacturaTicketComponent from "@/components/wms/recepcion/RecepcionFacturaTicketComponent";
import RecepcionFacturaDetalleComponent from "@/components/wms/recepcion/RecepcionFacturaDetalleComponent";
import RecepcionFacturaModalComponent from "@/components/wms/recepcion/RecepcionFacturaModalComponent";
import SubirFacturaScanModalComponent from "@/components/wms/recepcion/SubirFacturaScanModalComponent";
import ReferencialModalComponent from "@/components/wms/recepcion/ReferencialModalComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProveedoresSelectComponent,
    ProductoSelectComponent,
    RecepcionFacturaTicketComponent,
    RecepcionFacturaDetalleComponent,
    RecepcionFacturaModalComponent,
    SubirFacturaScanModalComponent,
    ReferencialModalComponent,
  },
  data() {
    return {
      factura: {
        errors: [],
      },
      tipo: "FACTURAS",
      seleccionada: null,
      nueva_etiqueta: {
        cantidad: 1,
        errors: {
          cantidad: null,
        },
      },
      id_factura_editar: null,
      current: {
        referencia: "",
        id: null,
        estado_str: null,
        tienda: "",
        estado: "A",
        errors: [],
        bultoe_set: [],
        facturae_set: [],
        recepcionetiqueta_set: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    duplicarAnularRecepcion() {
      let self = this;
      Notifications.alert.confirm(
        "Duplicar y Anular Recepción",
        "Por favor tomar en cuenta que se anulara la recepción, y se duplicara con estado abierto para su corrección y posterior finalización",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "recepcion",
            self.current.id,
            "anular_duplicar_recepcion"
          )
            .then((response) => {
              let id = response.data;
              Notifications.alert.success(
                "Duplicar y Anular Recepción",
                "Realizado Exitosamente",
                ""
              );
              self.$router.push({
                name: "wms-recepcion-editar",
                params: { id: id },
              });
              self.refreshCurrent();
              self.deseleccionar();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Duplicar y Anular Recepción",
                error.response.data.detail
              );
            });
        }
      );
    },
    openModalEditarFact() {
      this.factura = this.seleccionada;
      this.factura.fecha_documento = moment(this.factura.fecha_documento).format(
        "DD/MM/YYYY"
      );
      $("#modalFactura1").modal("show");
    },
    editarFactura() {
      let self = this;
      let params = Object.assign({}, self.factura);
      if (params.id == null) {
        delete params.id;
      }
      if (params.fecha_documento) {
        params.fecha_documento = moment(params.fecha_documento).format("DD/MM/YYYY");
      }
      DynamicService.save("wms", "facturas", params)
        .then((res) => {
          self.$refs.cerrarModalFactura.click();
          self.refreshAll();
        })
        .catch((error) => {
          if (error) {
            self.factura.errors = error.response.data;
            if ("detail" in error.response.data) {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            }
          }
        });
    },
    autorizarTodo() {
      let self = this;
      Notifications.alert.confirm(
        "Autorizar todas las lineas de la factura",
        "¿Esta seguro?",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "facturas",
            self.seleccionada.id,
            "autorizar_todo"
          )
            .then((response) => {
              Notifications.alert.success(
                "Autorizar todas las lineas de la factura",
                "Realizado con exito"
              );
              self.refreshAll();
            })
            .catch((error) => {
              Notifications.alert.error("Autorizar Todo", error.response.data.detail);
            });
        }
      );
    },
    imprimir(detalle) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/recepcion/etiqueta.jrxml&id=${detalle.id}`
      );
    },
    imprimirAll() {
      let self = this;
      self.etiqueta = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/recepcion/etiqueta_all.jrxml&id=${self.etiqueta}`
      );
    },
    eliminar(detalle) {
      let self = this;
      let params = {
        etiqueta: detalle.etiqueta,
      };
      DynamicService.postAction(
        "wms",
        "recepcion",
        self.current.id,
        "eliminar_etiqueta",
        params
      )
        .then((res) => {
          self.refreshCurrent();
        })
        .catch((error) => {
          alert(error.response.data.detail);
        });
    },
    reporteDevolucion(current) {
      let self = this;
      self.recepcion = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/compras_locales/ingreso.jrxml&id=${self.recepcion}`
      );
    },
    reporteDiferencia(current) {
      let self = this;
      self.recepcion = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/recepcion/diferencia_precio/diferencia_precio_subreport.jrxml&id=${self.recepcion}`
      );
    },
    crearEtiquetas(e) {
      let self = this;
      e.preventDefault();
      let params = {
        cantidad: self.nueva_etiqueta.cantidad,
      };
      DynamicService.postAction(
        "wms",
        "recepcion",
        self.current.id,
        "crear_etiqueta",
        params
      )
        .then((res) => {
          self.refreshCurrent();
          self.nueva_etiqueta = {
            cantidad: 1,
            errors: {
              cantidad: null,
            },
          };
        })
        .catch((error) => {
          if (error) {
            self.nueva_etiqueta.errors = error.response.data;
          }
        });
    },
    refreshCurrent() {
      let self = this;
      RecepcionService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
      });
    },
    refreshFacturaE(facturae_id) {
      let self = this;
      RecepcionFacturaEService.getById(facturae_id).then((response) => {
        self.seleccionada = response.data;
      });
    },
    refreshAll() {
      this.refreshCurrent();
      this.refreshFacturaE(this.seleccionada.id);
    },
    deseleccionar() {
      this.seleccionada = null;
      this.refreshCurrent();
    },
    seleccionar(facturae_id) {
      this.refreshFacturaE(facturae_id);
    },
    cerrarFactura() {
      let self = this;
      DynamicService.postAction("wms", "facturas", self.seleccionada.id, "cerrar", {})
        .then((res) => {
          self.refreshCurrent();
          self.refreshFacturaE(self.seleccionada.id);
          Notifications.toast.success("Cerrar facturar", "Realizado correctamente");
        })
        .catch((error) => {
          Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
        });
    },
    anular() {
      let self = this;
      DynamicService.postAction("wms", "facturas", self.seleccionada.id, "anular", {})
        .then((res) => {
          self.refreshCurrent();
          self.refreshFacturaE(self.seleccionada.id);
          Notifications.toast.success("Anular facturar", "Realizado correctamente");
        })
        .catch((error) => {
          Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
        });
    },
    abrirFactura() {
      let self = this;

      DynamicService.postAction("wms", "facturas", self.seleccionada.id, "abrir", {})
        .then((res) => {
          self.refreshCurrent();
          self.refreshFacturaE(self.seleccionada.id);
          Notifications.toast.success("Abrir facturar", "Realizado correctamente");
        })
        .catch((error) => {
          Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
        });
    },
    finalizarRecepcion() {
      let self = this;
      let fecha_proceso = localStorage.getItem("fecha_proceso");
      fecha_proceso = new Date(fecha_proceso);
      if (fecha_proceso) {
        fecha_proceso.setSeconds(fecha_proceso.getSeconds() + 45);
        if (fecha_proceso > new Date()) {
          let tiempo_espera = fecha_proceso - new Date();
          tiempo_espera = Math.floor(tiempo_espera / 1000);
          Notifications.alert.error(
            "Finalizar Recepción",
            "Este proceso solo se puede ejecutar una vez cada 45 seg, faltan  " +
              tiempo_espera +
              " seg. para el proximo intento"
          );
          self.refreshCurrent();
          return;
        }
      }
      Notifications.alert.confirm(
        "Finalizar Recepción de Productos",
        "¿Desea finalizar la recepción de productos, no podrá realizar ninguna modificacion luego de realizar esta acción?",
        "Si Finalizar",
        function () {
          self.refreshCurrent();
          localStorage.setItem("fecha_proceso", new Date());
          DynamicService.postAction(
            "wms",
            "recepcion",
            self.current.id,
            "finalizar_recepcion",
            {}
          )
            .then((res) => {
              self.refreshCurrent();
              Notifications.toast.success(
                "Finalizar Recepción",
                "Realizado correctamente"
              );
            })
            .catch((error) => {
              localStorage.removeItem("fecha_proceso");
              if ("detail" in error.response.data) {
                Notifications.alert.error(
                  "Finalizar Recepción",
                  error.response.data.detail
                );
              } else {
                let erorrs = "";
                error.response.data.map(function (value, key) {
                  erorrs += value;
                });
                Notifications.alert.error("Finalizar Recepción", erorrs);
              }
            });
        }
      );
    },
  },
};
</script>
